import styled from '@emotion/styled'
import { theme } from 'app/theme'
import { rgba } from 'emotion-rgba'
import React, { memo } from 'react'

export const Overlay = memo(function Overlay() {
  return <Container />
})

const Container = styled.div`
  width: 100%;
  height: 100%;
  background: ${rgba(theme.colors.variants.neutralDark1, 0.3)};
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  &:before,
  &:after {
    content: '';
    width: 100%;
    height: 11.25rem;
    pointer-events: none;
    position: absolute;
    left: 0;
  }
  &:before {
    background: linear-gradient(
      ${rgba(theme.colors.variants.neutralDark1, 0.6)},
      ${rgba(theme.colors.variants.neutralDark1, 0)}
    );
    top: 0;
  }
  &:after {
    background: linear-gradient(
      ${rgba(theme.colors.variants.neutralDark1, 0)},
      ${rgba(theme.colors.variants.neutralDark1, 0.7)}
    );
    bottom: 0;
  }
`
